(() => {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    const nav = document.querySelector('[data-site-nav]');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    nav?.classList.toggle('is-open');
  });


  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const data = form.querySelector('[data-product-json]');
    const idInput = form.querySelector('[data-variant-id]');
    const submit = form.querySelector('[data-submit-button]');
    if (!data || !idInput) return;
    let variants = [];
    try { variants = JSON.parse(data.textContent); } catch (error) { return; }
    const updateVariant = () => {
      const selected = Array.from(form.querySelectorAll('[data-option-select]')).map((select) => select.value);
      const variant = variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      idInput.value = variant.id;
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'Add personalised item to cart' : 'Sold out';
      }
    };
    form.querySelectorAll('[data-option-select]').forEach((select) => select.addEventListener('change', updateVariant));
  });
})();
